import type { PcMonitorListing } from '../../types/pcmonitor.ts';
import { formatChf } from './listingMath.ts';

interface AskingPriceProps {
  listing: PcMonitorListing;
}

/**
 * Asking price. CHO-698: an unresolved price renders as a badge — never a
 * number, no matter which column it appears in.
 */
export default function AskingPrice({ listing }: AskingPriceProps) {
  if (!listing.price_resolved || listing.asking_price == null) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 border border-amber-200">
        Price unresolved
      </span>
    );
  }
  return (
    <span className="font-semibold tabular-nums text-gray-900">
      {formatChf(listing.asking_price)}
    </span>
  );
}
